import React from 'react'
import { useTranslation } from 'react-i18next'

import getProductsToBuy, { GetProductsToBuyResponse } from 'core/application/adminDashboard/ourProducts/productsToBuy'

import { Alert, Card, Row, Skeleton } from 'common/components'
import { useLoginUser, useLoginUserV2, useQueryRequest, useQueryRequestV2 } from 'common/hooks'

import ProductCard from './common/ProductCard'

const OurProducts = () => {
  const { t: translate } = useTranslation()
  const { user } = useLoginUserV2()
  const { data: productsToBuy, isLoading: productsLoading } = useQueryRequestV2<GetProductsToBuyResponse[]>({
    initialState: [],
    queryFn: () => getProductsToBuy(),
  })

  return (
    <Card title={<h5 className="mb-0">{translate('admin-dashboard.left-navigation.our-products')}</h5>}>
      <Skeleton loading={productsLoading}>
        <Row gutter={[16, 16]}>
          {productsToBuy
            .sort((a, b) => {
              if (a.isInUse) return -1
              return 1
            })
            .sort((a, b) => {
              if (a.id === user.productId) return -1
              return 1
            })
            .map((product) => (
              <ProductCard product={product} isCurrent={product.id === user.productId} />
            ))}
        </Row>
      </Skeleton>
    </Card>
  )
}

export default OurProducts
